// Add your constant here, any text that you use in our application,
export const TEXT_CONSTANTS = {
  CREATE_VISIT: "Create Visit",
  IMPORT_TEMPLATE: "Import Template",
  INTERVAL_NOTES: "Interval Notes (optional)",
  SUBJECTIVE: "Subjective",
  NO_ORDER_FOUND: "No Order Found",
  CANCEL: "Cancel",
  SAVE_AS_DRAFT: "Save as Draft",
  PROCEED_TO_DISCHARGE: "Proceed to Discharge",
  SAVE: "Save",
  PRINT: "Print",
  FULL_NAME: "Full Name",
  ACTION: "Actions",
  PATIENT_LIST: "Patient List",
  OPEN_HEALTH_HISTORY: "Open Health History",
  CREATE_ORDER: "Create Order",
  ORDER_TYPE: "Order Type",
  MEDICATION_NAME: "Medication Name",
  NOTES: "Notes",
  DATES: "Dates",
  TRANSFER: "Transfer",
  CHIEF_COMPLAINT: "Chief Complaint",
  ENTER_CHIEF_COMPLAINT: "Enter Chief Complaint",
  PROVIDER_TASKS: "Provider Tasks",
  TASKS: "Tasks",
  INVENTORY_LIST: "Inventory List",
  FREQUENCY: "Frequency",
  CONTACT_DIRECTORY: "Contact Directory",
  CLEAR_ALL: "Clear All",
  APPLY: "Apply",
  CLOSE: "Close",

  // Add more text as needed
};
